module.exports = __webpack_public_path__ + "static/media/bank_cards.804d6e42.svg";